<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
  >
    <div
      class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between"
    >
      <div class="trezo-card-title">
        <h5 class="mb-0">Testimonials Style - 6</h5>
      </div>
    </div>
    <div class="trezo-card-content">
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-[25px]">
        <div class="text-center">
          <img
            src="@/assets/images/users/user9.jpg"
            width="100"
            alt="user-image"
            class="inline-block rounded-full"
          />
          <h5 class="mt-[15px] mb-[7px]">Jason Lee</h5>
          <span class="block"> Physician Assistant </span>
          <div
            class="leading-none text-[#fe7a36] my-[15px] text-md flex items-center justify-center gap-[2px]"
          >
            <i class="ri-star-fill"></i>
            <i class="ri-star-fill"></i>
            <i class="ri-star-fill"></i>
            <i class="ri-star-fill"></i>
            <i class="ri-star-fill"></i>
          </div>
          <p>
            "Statistics is the science of using data to make decisions. This is
            relevant in almost all fields of work and there are many
            opportunities for employment."
          </p>
        </div>
        <div class="text-center">
          <img
            src="@/assets/images/users/user10.jpg"
            width="100"
            alt="user-image"
            class="inline-block rounded-full"
          />
          <h5 class="mt-[15px] mb-[7px]">Ashley Davis</h5>
          <span class="block"> Data Scientist </span>
          <div
            class="leading-none text-[#fe7a36] my-[15px] text-md flex items-center justify-center gap-[2px]"
          >
            <i class="ri-star-fill"></i>
            <i class="ri-star-fill"></i>
            <i class="ri-star-fill"></i>
            <i class="ri-star-fill"></i>
            <i class="ri-star-half-line"></i>
          </div>
          <p>
            "Statistics is the science of using data to make decisions. This is
            relevant in almost all fields of work and there are many
            opportunities for employment."
          </p>
        </div>
        <div class="text-center">
          <img
            src="@/assets/images/users/user11.jpg"
            width="100"
            alt="user-image"
            class="inline-block rounded-full"
          />
          <h5 class="mt-[15px] mb-[7px]">Alex Rocky</h5>
          <span class="block"> Marketing Manager </span>
          <div
            class="leading-none text-[#fe7a36] my-[15px] text-md flex items-center justify-center gap-[2px]"
          >
            <i class="ri-star-fill"></i>
            <i class="ri-star-fill"></i>
            <i class="ri-star-fill"></i>
            <i class="ri-star-fill"></i>
            <i class="ri-star-line"></i>
          </div>
          <p>
            "Statistics is the science of using data to make decisions. This is
            relevant in almost all fields of work and there are many
            opportunities for employment."
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TestimonialsStyleSix",
};
</script>
